import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import VisionLogo from "@/components/shared/VisionLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Connexion réussie");
      const u = res.user;
      if (u.role === "super_admin") navigate("/admin");
      else if (u.store_slug) navigate(`/store/${u.store_slug}/admin`);
      else navigate("/");
    } else toast.error(res.error);
  };

  return (
    <div className="vp-dark min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Link to="/"><VisionLogo variant="dark" size={46} /></Link>
        </div>
        <div className="vp-card rounded-2xl p-8">
          <h1 className="font-display text-3xl font-bold text-white mb-1">Connexion</h1>
          <p className="text-sm text-slate-400 mb-6">Accédez à votre espace de gestion</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-300 text-sm mb-1.5 block">Email</Label>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
                data-testid="login-email" className="bg-black/30 border-white/10 text-white" placeholder="vous@boutique.com" />
            </div>
            <div>
              <div className="flex justify-between mb-1.5">
                <Label className="text-slate-300 text-sm">Mot de passe</Label>
                <Link to="/forgot-password" className="text-xs vp-accent-text hover:underline">Oublié ?</Link>
              </div>
              <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
                data-testid="login-password" className="bg-black/30 border-white/10 text-white" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full vp-accent-bg text-black font-semibold hover:opacity-90">
              {loading && <Loader2 className="animate-spin mr-2" size={16} />} Se connecter
            </Button>
          </form>
          <div className="flex items-center gap-3 my-5">
            <div className="h-px flex-1 bg-white/10" /><span className="text-xs text-slate-500">ou</span><div className="h-px flex-1 bg-white/10" />
          </div>
          <Button onClick={googleLogin} variant="outline" data-testid="login-google" className="w-full bg-white text-black hover:bg-slate-100 border-0 font-medium">
            Continuer avec Google
          </Button>
          <p className="text-center text-sm text-slate-400 mt-6">
            Pas encore de boutique ? <Link to="/register" className="vp-accent-text hover:underline">Créer un compte</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
